// --- Styles
import styles from '../details-table.module.scss';
// --- Utilities
import ReactHtmlParser from 'react-html-parser';
import DOMPurify from 'dompurify';

/**
 * CommentBodyDetailsRow Component
 *
 * This component is responsible for rendering the body of a comment in the details row.
 * It uses ReactHtmlParser to parse and render HTML content safely.
 * It is designed to display the comment body in a grid layout.
 *
 * @param {Object} data - The data object containing the comment body.
 * @returns {JSX.Element} The rendered details row with the comment body.
 */
export const CommentBodyDetailsRow = ({ data }) => {

    return (
        <>
            <div className={'data-grid-container'}>
                <div className={styles['details-row']}>
                    <div className={styles['row-item']} key={window.crypto.randomUUID()}>
                        {ReactHtmlParser(DOMPurify.sanitize(data?.body))}
                    </div>
                </div>
            </div>
        </>
    );
};
